import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Home from './pages/Home';
import Events from './pages/Events';
import Library from './pages/Library';
import Admin from './pages/Admin';
import Services from './pages/Services';
import Arcades from './pages/Arcades';
import EventSupportRequest from "./pages/EventSupportRequest";

// 🔒 Admin Route Guard
const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));

  // not logged in OR not admin → bounce
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/library" element={<Library />} />
        <Route path="/services" element={<Services />} />
        <Route path="/arcades" element={<Arcades />} />
        <Route path="/event-support" element={<EventSupportRequest />}
/>

        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />

        {/* Optional: catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;